import {useCallback, useEffect} from "react";
import {useStateContext} from "../contexts/ContextProvider";
import {getAuthenticatedUser} from "../api/apiClient";

export const useInitAuthenticatedUser = () => {
    const {setUser, setToken} = useStateContext();
    const initUser = useCallback(async () => {
        try {
            const data = await getAuthenticatedUser();
            setUser({
                firstName : data.firstName,
                lastName  : data.lastName,
                email     : data.email,
                birthDate : data.birthDate,
                phone     : data.phone,
                gender    : data.gender,
                street    : data.street,
                zip       : data.zip,
                city      : data.city,
            })
        }
        catch (error) {
            console.log(error);

            let errorData;
            try {
                errorData = JSON.parse(error.message);
            } catch (parseError) {
                errorData = null;
            }

            if (errorData?.status === 401) {
                setUser({});
                setToken(null);
            }
        }
    }, [setUser, setToken]);

    useEffect(() => {
        const abortController = new AbortController();

        initUser();

        return () => {
            abortController.abort()
        };
    }, [initUser]);

    return;
};